import React from "react";

import images from "assets/images";

export const SocialNavigation = () => (
  <div className="smm">
    <ul className="smm__list">
      <li className="smm__item">
        <a href="">
          <img src={images.logoFacebook} alt="Facebook" />
        </a>
      </li>
      <li className="smm__item">
        <a href="">
          <img src={images.logoTwitter} alt="Twitter" />
        </a>
      </li>
    </ul>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/SocialNavigation.jsx